import { useEffect, useRef } from 'react';

import { useLocation, useNavigationType } from 'react-router';

import { PageType, pageTypeMapping } from '../types/enum';

import { useAppDispatch } from '../redux/hooks';
import { addPoppedUrl, setPage } from '../redux/selvtestSlice';

export const useHistoryListen = (): void => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const dispatch = useAppDispatch();
  const historyRef = useRef<string[]>([]);

  useEffect(() => {
    const isQuizPage = location.pathname.startsWith('/quiz/') || location.pathname.includes(pageTypeMapping(PageType.quizsvar));
    historyRef.current = [...historyRef.current, location.pathname];
    if (navigationType === 'POP' && isQuizPage) {
      const lastPath = historyRef.current[historyRef.current.length - 2];
      const currentPath = historyRef.current[historyRef.current.length - 1];
      // Vi holder på en liste av sider vi har gått tilbake fra - slik at vi kan slette svarene derfra
      dispatch(addPoppedUrl({ lastPath, currentPath }));
      // Settes nåværende side etter addPoppedUrl har brukt forrige nåværende side i sjekken sin
      dispatch(setPage(location.pathname));
    } else if (navigationType === 'PUSH' && isQuizPage) {
      dispatch(setPage(location.pathname));
    }
  }, [location, navigationType, dispatch]);
};
